<template>
   
        <span :style="{color:color}">{{  formatTime }}</span>
</template>

<script setup>

import { ref, onMounted, onBeforeUnmount, watch } from 'vue';
let formatTime = ref(''); //格式化后的时间
let day=ref(null)
let hours=ref(null)
let minute=ref(null)
let second=ref(null)
const props = defineProps({
    totalTime: Number, //总时长 -1未开始 0已结束
    interval: { //时间间隔
        type: Number,
        default: 1000
    },
    color:String
})


watch(() => props.totalTime, (newVal, oldVal) => {
    totalTime = newVal;
    stopCountDown()
    startCountDown()

})
const secondToTimeStr = (t,type) => {
    let timeStr0='', timeStr1 = '', timeStr2 = '', timeStr3 = '';
    if (type == 0) {
        timeStr1 = ':'; timeStr2 = ':'; timeStr3 = ':';
    }else if (type == 1) {
        timeStr0='天',  timeStr1 = '小时'; timeStr2 = '分'; timeStr3 = '秒'
       
    };
    
    if (!t) return;
    if (t < 60) return "00" + timeStr2 + ((i = t) < 10 ? "0" + i : i);
    if (t < 3600) return "" + ((a = parseInt(t / 60)) < 10 ? "0" + a : a) + timeStr2 + ((i = t % 60) < 10 ? "0" + i : i);
    if (3600 <= t) {
        var a, i, e = parseInt(t / 3600 % 24);
        var d = parseInt(t / 3600 / 24) //算出天数
        if (type == 0) {
            return (e < 10 ? "0" + e : e) + timeStr1 + ((a = parseInt(t % 3600 / 60)) < 10 ? "0" + a : a) + timeStr2 + ((i = t % 60) < 10 ? "0" + i : i);
        } else if (type == 1) {
            day.value=(d < 10 ? "0" + d : d)
             hours.value = (e < 10 ? "0" + e : e);
              minute.value = ((a = parseInt(t % 3600 / 60)) < 10 ? "0" + a : a);
               second.value = ((i = t % 60) < 10 ? "0" + i : i);
            return (d < 10 ? "0" + d : d) + timeStr0+ (e < 10 ? "0" + e : e) + timeStr1 + ((a = parseInt(t % 3600 / 60)) < 10 ? "0" + a : a) + timeStr2 + ((i = t % 60) < 10 ? "0" + i : i) + timeStr3;
        }
    }
}


//时间间隔
const interval = props.interval;
//总时间
let totalTime = props.totalTime
//用来计次数
let count = 0
//开始倒计时的时间
let firstTimer = new Date().getTime();
let timer=  null | undefined;

// 倒计时回调
const func = () => {
    count++
    let delaytimer = new Date().getTime() - (interval * count + firstTimer)

    let nextTimer = interval - delaytimer
    if (nextTimer < 0) {
        nextTimer = 0
    }
    totalTime -= interval / 1000;
    // console.log(`延迟：${delaytimer}ms, 下一次执行：${nextTimer}ms, 还剩：${totalTime}ms。`)
    formatTime.value = secondToTimeStr(totalTime, 1);
    if (totalTime <= 0) {
        formatTime.value = "已结束";
        clearTimeout(timer)
    } else {
        timer = setTimeout(func, nextTimer)
    }
}




//暂停倒计时
const stopCountDown = () => {
    clearTimeout(timer)
}

//开始倒计时
const startCountDown = () => {
    if (totalTime == 0) {
        formatTime.value = "已结束";
    } else if (totalTime <= -1) {
        formatTime.value = "未开始";
    } else {
        count = 0;
        firstTimer = new Date().getTime();
        timer = setTimeout(func, interval)
    }
}

//在开始和结束前要调接口做校对,获取剩余时长传给totalTime
startCountDown();


//暴漏给父组件的方法
defineExpose({
    stopCountDown,
    startCountDown
})


onBeforeUnmount(() => {
    clearTimeout(timer);
})
</script>
<style lang="less" scoped>
.count_item{
    background-position: center;
  background-repeat: no-repeat;
  background-size: contain;
  width: 101px;
  height: 73px;
  color: #ffffff;
  font-size: 65px;
  font-stretch: condensed;
  font-weight: 600;
  text-align: center;
  line-height: 73px;
  letter-spacing:12px;
  padding-left: 5px;
}
.count_span{
    background-position: center;
  background-repeat: no-repeat;
  background-size: contain;
  width: 26.35px;
  height: 101.35px;
  background-image: url('../assets/static/images/jj_countdown_red_f.png');
}
.ml8{margin-left: 8px;}
</style>
